import PropTypes from 'prop-types';
import {NavLink, useLocation} from 'react-router-dom';
import {Translate} from 'react-redux-i18n';

function TabView(props) {
  const location = useLocation();

  const isLinkActive = () => location.pathname.startsWith(props.link.substring(0, props.link.length - 1));

  return (
    <NavLink
      to={props.link}
      isActive={isLinkActive}
      disabled={props.disabled}
    >
      <div className="badge-container">
        <Translate value={props.label}/>
        {props.dashboardActionCount !== undefined && props.dashboardActionCount > 0 &&
          <span className="badge small red">{props.dashboardActionCount}</span>
        }
      </div>
    </NavLink>
  );
}

TabView.propTypes = {
  label: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  dashboardActionCount: PropTypes.number
};

export default TabView;
